import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    listStyle: 'none',
    margin: 0,
    marginTop: 16,
    padding: `0 0px`
  },
  listItem: {
    padding: `8px 0`,
    borderBottom: `1px solid`,
    borderBottomColor: theme.palette.grey[600],
    display: 'flex',
    alignItems: `flex-start`,
    justifyContent: `flex-start`,
    '&:last-child': {
      borderBottom: 'none'
    },
    '& strong': {
      minWidth: 116
    },
    '& a': {
      color: '#fff'
    }
  }
}))

const DescriptionList = ({ items, ...props }) => {
  const classes = useStyles()
  return (
    <ul className={classes.root}>
      {items.map((item, idx) => (
        <li key={idx} className={classes.listItem}>
          {item[0] !== 'Description' && (
            <strong>{item[0]}:</strong>
          )}
          <span
            dangerouslySetInnerHTML={{
              __html: item[1]
            }}></span>
        </li>
      ))}
    </ul>
  )
}

DescriptionList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string)
  )
}

export default DescriptionList
